import React           from 'react'
import CollectingCards from './collecting-cards'
import RoundStarting   from './round-starting'
import TurnStarting    from './turn-starting'
import TurnInProgress  from './turn-in-progress'
import TurnFinished    from './turn-finished'
import RoundFinished   from './round-finished'
import GameFinished    from './game-finished'
import Statistics      from './statistics'

function Empty() {
  return <p>Yikes! I have no idea what is happening...</p>
}

export default function Phases ({ game, isFunmaster, onCreateCard, onCheated, onGuess, onNext }) {
  if (!isFunmaster && game.status !== 'collecting_cards') {
    return <Statistics game={ game } />
  }

  let Component = {
    collecting_cards : CollectingCards,
    round_starting   : RoundStarting,
    turn_starting    : TurnStarting,
    turn_in_progress : TurnInProgress,
    turn_finished    : TurnFinished,
    round_finished   : RoundFinished,
    game_finished    : GameFinished
  }[game.status]    || Empty

  return (<Component game={ game }
                     isFunmaster={ isFunmaster }
                     onCreateCard={ onCreateCard }
                     onGuess={ onGuess }
                     onCheated={ onCheated }
                     onNext={ onNext } />)
}



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/phases/index.jsx
 **/